import repository from './repository';
import axios from "axios";

const API = process.env.VUE_APP_API_URL;
const axiosConfig = {withCredentials: true};
let repo = repository('/tasks');

repo.getTasks = (pageNumber, projectId, subscriberId, fromDate, tillDate, state) => {
    let queryString = "?page=" + pageNumber + "&projectId=" + projectId + "&subscriberId=" + subscriberId;
    fromDate != null && fromDate !== "" ? queryString += "&from=" + fromDate : null;
    tillDate != null && tillDate !== "" ? queryString += "&till=" + tillDate : null;
    state != null && state !== 'All' ? queryString += "&state=" + state : null;
    return axios.get(API + "/tasks" + queryString);
};

repo.getFilterOptions = () => {
    return axios.get(API + '/tasks/filterOptions');
};

repo.getTaskDetail = (id) => {
    return axios.get(API + '/tasks/detail/' + id);
};

repo.retryTask = (id) => {
    return axios.get(API + '/tasks/retry/' + id);
};
export default repo;
